import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { NavigationArrow, MapPin, Phone } from '@phosphor-icons/react';
import { formatDate, formatTime } from '../../lib/utils';
import { getStatusBadgeClass, getStatusIcon } from './constants';

export const VisitsTable = ({ visits, loading, onValidate, onRecordFirst }) => (
  <Card className="border-slate-200">
    <CardContent className="p-0">
      {loading ? (
        <div className="flex items-center justify-center h-64">
          <div className="w-8 h-8 border-4 border-indigo-900 border-t-transparent rounded-full animate-spin" />
        </div>
      ) : visits.length === 0 ? (
        <div className="text-center py-12">
          <NavigationArrow size={48} className="mx-auto mb-4 text-slate-300" />
          <p className="text-slate-500">No EVV visits recorded</p>
          <Button
            variant="link"
            className="text-indigo-600 mt-2"
            onClick={onRecordFirst}
            data-testid="record-first-visit-btn"
          >
            Record your first visit
          </Button>
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Employee</TableHead>
              <TableHead>Patient</TableHead>
              <TableHead>Time</TableHead>
              <TableHead>Method</TableHead>
              <TableHead>Location</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {visits.map((visit) => (
              <TableRow key={visit.id}>
                <TableCell>{formatDate(visit.service_date)}</TableCell>
                <TableCell>
                  <p className="font-medium">{visit.employee_name}</p>
                </TableCell>
                <TableCell>
                  <p className="font-medium">{visit.patient_name}</p>
                </TableCell>
                <TableCell>
                  <p className="text-sm">
                    {formatTime(visit.time_in)} - {formatTime(visit.time_out)}
                  </p>
                </TableCell>
                <TableCell>
                  <Badge variant="outline" className="bg-slate-50">
                    {visit.verification_method === 'GPS' && (
                      <MapPin size={12} className="mr-1" />
                    )}
                    {visit.verification_method === 'Telephony' && (
                      <Phone size={12} className="mr-1" />
                    )}
                    {visit.verification_method}
                  </Badge>
                </TableCell>
                <TableCell>
                  {visit.clock_in_latitude ? (
                    <span className="text-xs font-mono text-slate-500">
                      {visit.clock_in_latitude.toFixed(4)},{' '}
                      {visit.clock_in_longitude.toFixed(4)}
                    </span>
                  ) : (
                    <span className="text-xs text-slate-400">No GPS</span>
                  )}
                </TableCell>
                <TableCell>
                  <Badge
                    variant="outline"
                    className={getStatusBadgeClass(visit.validation_status)}
                  >
                    <span className="flex items-center gap-1">
                      {getStatusIcon(visit.validation_status)}
                      {visit.validation_status}
                    </span>
                  </Badge>
                </TableCell>
                <TableCell>
                  {visit.validation_status === 'Pending' && (
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onValidate(visit.id)}
                      data-testid={`validate-visit-${visit.id}`}
                    >
                      Validate
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </CardContent>
  </Card>
);
